import * as React from 'react';
import type { NovaFacade } from '@office-start/nova-facade-types';
import { NovaFacadeContext } from '@office-start/nova-facade-react';
import { novaGraphQL } from './NovaGraphQL';
import { novaLocalization } from './NovaLocalization';
import { novaCommanding } from './NovaCommanding';

export interface NovaProviderProps {
    children: React.ReactNode;
}

export const NovaContextProvider: React.FunctionComponent<NovaProviderProps> = props => {
    const { children } = props;

    // Setup commanding context value
    const novaFacade: NovaFacade = {
        commanding: novaCommanding,
        graphql: novaGraphQL,
        localization: novaLocalization,
    };

    return <NovaFacadeContext.Provider value={novaFacade}>{children}</NovaFacadeContext.Provider>;
};

NovaContextProvider.displayName = 'NovaContextProvider';
